import axios from "utils/axios";

export const getProvinces = (params) => {
  return axios.get("/provinces", { params });
};
